import type { NoteName } from './notesAndAccidentals';

export const voiceTypes = [
  'soprano',
  'mezzo-soprano',
  'alto',
  'tenor',
  'baritone',
  'bass',
] as const;
export type VoiceType = typeof voiceTypes[number];

export const vocalRanges: Record<
  VoiceType,
  { lowestNoteName: NoteName; highestNoteName: NoteName }
> = {
  soprano: {
    lowestNoteName: 'C4',
    highestNoteName: 'F5',
  },
  'mezzo-soprano': {
    lowestNoteName: 'Bb3',
    highestNoteName: 'Eb5',
  },
  alto: {
    lowestNoteName: 'G3',
    highestNoteName: 'C5',
  },
  tenor: {
    lowestNoteName: 'C3',
    highestNoteName: 'F4',
  },
  baritone: {
    lowestNoteName: 'A2',
    highestNoteName: 'D4',
  },
  bass: {
    lowestNoteName: 'G2',
    highestNoteName: 'C4',
  },
};

export const singersByVoiceType: Record<VoiceType, string[]> = {
  soprano: ['Mariah Carey', 'Ariana Grande', 'Renée Flemming'],
  'mezzo-soprano': ['Beyoncé', 'Sheryl Crow', 'Jessye Norman'],
  alto: ['Cher', 'Judy Garland', 'Marian Anderson'],
  tenor: ['Stevie Wonder', 'Freddie Mercury', 'Luciano Pavarotti'],
  baritone: ['Frank Sinatra', 'Nat King Cole', 'Michael Bublé'],
  bass: ['Johnny Cash', 'Barry White', 'Paul Robeson'],
};
